module.exports = __webpack_public_path__ + "static/media/8.0ef0c5d8.svg";